const routePaths = {
  project: 'p',
}
// Route for project views
export const getProjectViewPath = (projectUuid: string, viewId: string | number) =>
  `/${routePaths.project}/${projectUuid}/views/${viewId}`

export default routePaths
